import React, { useState } from 'react';
import axios from '../config/axiosConfig'; 
import './DonateModal.css';
import { useTranslation } from '../contexts/TranslationContext';

const DonateModal = ({ onClose, onDonate }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    donor_name: '',
    donor_email: '',
    donor_phone: '',
    amount: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post('https://hsn.urugowoc.org.rw/backend/api/donate', {
        ...formData,
        amount: parseFloat(formData.amount)
      });

      setSuccess(true);
      setTimeout(() => {
        onClose();
        onDonate();
      }, 5000);
    } catch (error) {
      console.error('Error submitting donation:', error);
      alert(t('errorMessage'));
    } finally {
      setLoading(false);
    }
  };

  const presetAmounts = [5000, 10000, 25000, 50000, 100000];

  return (
    <div className="donation-modal-overlay">
      <div className="donation-modal-content">
        <button className="donation-close-modal" onClick={onClose}>×</button>
        
        <div className="donation-modal-header">
          <h2>{t('donateTitle')}</h2>
          <p>{t('donateDescription')}</p>
        </div>

        {success ? (
          <div className="donation-success-message">
            <h3>{t('successTitle')}</h3>
            <p>{t('successMessage')}</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="donation-form">
            <div className="donation-preset-amounts">
              <p>{t('quickSelectAmount')}</p>
              <div className="donation-amount-buttons">
                {presetAmounts.map(amount => (
                  <button
                    key={amount}
                    type="button"
                    className={`donation-amount-btn ${formData.amount === amount.toString() ? 'donation-selected' : ''}`}
                    onClick={() => setFormData({ ...formData, amount: amount.toString() })}
                  >
                    {amount.toLocaleString()} RWF
                  </button>
                ))}
              </div>
            </div>

            <div className="donation-form-group">
              <label>{t('donationAmountLabel')}</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                onChange={handleChange}
                placeholder={t('donationAmountPlaceholder')}
                required
                min="100"
                className="donation-input"
              />
            </div>

            <div className="donation-form-group">
              <label>{t('donorNameLabel')}</label>
              <input
                type="text"
                name="donor_name"
                value={formData.donor_name}
                onChange={handleChange}
                placeholder={t('donorNamePlaceholder')}
                required
                className="donation-input"
              />
            </div>

            <div className="donation-form-row">
              <div className="donation-form-group donation-half-width">
                <label>{t('emailLabel')}</label>
                <input
                  type="email"
                  name="donor_email"
                  value={formData.donor_email}
                  onChange={handleChange}
                  placeholder={t('emailPlaceholder')}
                  className="donation-input"
                />
              </div>

              <div className="donation-form-group donation-half-width">
                <label>{t('phoneLabel')}</label>
                <input
                  type="tel"
                  name="donor_phone"
                  value={formData.donor_phone}
                  onChange={handleChange}
                  placeholder={t('phonePlaceholder')}
                  className="donation-input"
                />
              </div>
            </div>

            <div className="donation-form-group">
              <label>{t('messageLabel')}</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder={t('messagePlaceholder')}
                rows="3"
                className="donation-textarea"
              />
            </div>

            <div className="donation-info-box">
              <p>{t('donationInfo1')}</p>
              <p>{t('donationInfo2')}</p>
              <p><strong>{t('donationInfo3')}</strong></p>
              <p><strong>{t('donationInfo4')}</strong></p>
              <p><strong>{t('donationInfo5')}</strong></p>
              <p><strong>{t('donationInfo6')}</strong></p>
              <p><strong>{t('donationInfo7')}</strong></p>
            </div>

            <div className="donation-modal-actions">
              <button type="button" className="donation-btn donation-btn-outline" onClick={onClose}>
                {t('cancelButton')}
              </button>
              <button type="submit" className="donation-btn donation-btn-primary" disabled={loading}>
                {loading ? t('processingButton') : t('makeDonationButton')}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default DonateModal;